import { useEffect } from "react";
import { SERVER_URL } from "../../../config/config";
import { SSE_HEADER } from "../../../constants/sse";
import { parseHelperBotEndedInfo } from "../../../helper/game";
import { HelperBotEndInfo } from "../../../types/HelperBotEndInfo";

const useHelperBotSSE = (
  account: string,
  onStarted: () => void,
  onEnded: (botEndedInfo: HelperBotEndInfo) => void
) => {
  useEffect(() => {
    const eventSource = new EventSource(`${SERVER_URL}/event/helperbot`);
    eventSource.onmessage = (e) => {
      if (e.data.includes("welcome")) {
      } else if (e.data.includes("eventName")) {
        const event = JSON.parse(e.data);
        console.log(event);

        if (event.eventName === SSE_HEADER.HELPER_BOT.HELPER_BOT_STARTED) {
          onStarted();
        } else if (event.eventName === SSE_HEADER.HELPER_BOT.HELPER_BOT_ENDED) {
          const endedInfo = parseHelperBotEndedInfo(event.data);
          if (endedInfo.user.toLowerCase() === account.toLowerCase()) {
            onEnded(endedInfo);
          }
        }
      }
    };

    return () => {
      eventSource.close();
    };
  }, [account, onEnded, onStarted]);
};

export default useHelperBotSSE;
